export default {
  "withdrawApproval.title": "提现审批",
  "withdrawApproval.thead.index": "#序号",
  "withdrawApproval.thead.applyId": "申请ID",
  "withdrawApproval.thead.userno": "会员ID",
  "withdrawApproval.thead.accountNo": "账号",
  "withdrawApproval.thead.accountName": "账户名",
  "withdrawApproval.thead.bankCode": "银行代码",
  "withdrawApproval.thead.email": "邮箱",
  "withdrawApproval.thead.remark": "备注",
  "withdrawApproval.thead.amount": "金额",
  "withdrawApproval.thead.payoutAmount": "派发金额",
  "withdrawApproval.thead.applyStatusDesc": "申请状态",
  "withdrawApproval.thead.payoutNum": "派发次数",
  "withdrawApproval.thead.ipRepeatNum": "IP重复次数",
  "withdrawApproval.thead.platformDesc": "出款方式",
  "withdrawApproval.thead.platformId": "提现平台",
  "withdrawApproval.thead.withdrawLimit": "会员限制流水",
  "withdrawApproval.thead.firstName": "名字",
  "withdrawApproval.thead.lastName": "姓氏",
  "withdrawApproval.thead.nickName": "昵称",
  "withdrawApproval.thead.document": "证件",
  "withdrawApproval.thead.source": "来源",
  "withdrawApproval.thead.createTime": "申请取款时间",
  "withdrawApproval.thead.modifyTime": "修改时间",
  "withdrawApproval.thead.action": "操作",
  "withdrawApproval.action.details": "详情",
  "withdrawApproval.action.pass": "代付",
  "withdrawApproval.action.Pass": "代付",
  "withdrawApproval.action.reject": "拒绝",
  "withdrawApproval.action.Reject": "拒绝",
  "withdrawApproval.tooltip.copyUserNo": "复制会员ID: {text}",
  "withdrawApproval.tooltip.userDetails": "显示用户详情",
  "withdrawApproval.copySuccess": "复制成功!",
  "withdrawApproval.confirm.content": "确定要{optWords}这个提现申请吗？",
  "withdrawApproval.confirm.ok": "确认",
  "withdrawApproval.confirm.cancel": "取消",
  "withdrawApproval.autoRefresh": "{seconds}秒后自动刷新列表",
  "withdrawApproval.autoWithdraw": "自动提现",
  "withdrawApproval.autoWithdraw.title": "{optWords}自动提现",
  "withdrawApproval.autoWithdraw.content": "确定要{optWords}自动提现吗？",
  "withdrawApproval.switch.open": "开启",
  "withdrawApproval.switch.Open": "开启",
  "withdrawApproval.switch.close": "关闭",
  "withdrawApproval.switch.Close": "关闭",
  "withdrawApproval.form.platformId": "请选择平台",
};
